import 'tailwindcss/tailwind.css';
import 'nprogress/nprogress.css';
import React, { useEffect } from 'react';
import type { AppProps } from 'next/app';
import { Web3ReactProvider } from '@web3-react/core';
import Web3 from 'web3';
import GenericPopupProvider from '@providers/GenericPopupProvider';
import MinifiedBridgeTransactionList from '@components/MinifiedBridgeTransactionList';
import OracleProvider from '@providers/OracleProvider';
import SendTransactionProvider from '@providers/SendTransactionProvider';
import TokenAssetsProvider from '@providers/TokenAssetsProvider';
import WalletsProvider from '@providers/WalletsProvider';
import NetworkEnvProvider from '@providers/NetworkEnvProvider';
import NProgress from 'nprogress';
import { useRouter } from 'next/router';
import { start as startBugsnag } from '@lib/bugsnag';
import Seo from '@components/Seo';
import * as ga from '@lib/ga';
import CronosUpgradeWarning from '@components/CronosUpgradeWarning';

const BASE_URL = process.env.NEXT_PUBLIC_CRONOS_ORACLE_BASE_URL ?? '';

const ErrorBoundary = startBugsnag();

function getLibrary(provider: any) {
  return new Web3(provider);
}

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) => ga.pageview(url);
    const startNProgress = () => NProgress.start();
    const endNProgress = () => NProgress.done();
    router.events.on('routeChangeStart', startNProgress);
    router.events.on('routeChangeComplete', endNProgress);
    router.events.on('routeChangeError', endNProgress);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', startNProgress);
      router.events.off('routeChangeComplete', endNProgress);
      router.events.off('routeChangeError', endNProgress);
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return (
    <ErrorBoundary>
      {/* <CronosUpgradeWarning> */}
      <NetworkEnvProvider>
        <OracleProvider baseUrl={BASE_URL}>
          <GenericPopupProvider>
            <Web3ReactProvider getLibrary={getLibrary}>
              <WalletsProvider>
                <TokenAssetsProvider>
                  <SendTransactionProvider>
                    <Seo
                      title="Cronos EVM Bridge | A Gateway For Cross-chain Assets Transfer On Cronos"
                      description="Cronos EVM Bridge is a Decentralised Bridge service providing the safest, fastest and the most secure way to transfer assets to and from Cronos EVM."
                    />
                    <MinifiedBridgeTransactionList />
                    <Component {...pageProps} />
                  </SendTransactionProvider>
                </TokenAssetsProvider>
              </WalletsProvider>
            </Web3ReactProvider>
          </GenericPopupProvider>
        </OracleProvider>
      </NetworkEnvProvider>
      {/* </CronosUpgradeWarning> */}
    </ErrorBoundary>
  );
}
export default MyApp;
